import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Analytics from "../../../../analytics";

export default class BodyPanelCheckbox extends Component {

  static propTypes = {
    activeSubPart: PropTypes.object.isRequired,
    toggleApplyWallsCheckbox: PropTypes.func.isRequired,
  };

  allWallsClick = () => {
    Analytics.sendClickEvent('all-walls-toggled');
    this.props.toggleApplyWallsCheckbox();
    setTimeout(() => {
      this.forceUpdate();
    }, 0)
  };

  render() {
    return (
      <button className="ui-checkbox-wrapper" onClick={this.allWallsClick}>
        <span className={"ui-checkbox" + (this.props.activeSubPart.getParent().allWallsApplied ? " ui-checkbox--checked" : "")}/>
        <span className="ui-checkbox__label">
          <FormattedMessage id="radioButtonAllWallsDesktop"/>
        </span>
      </button>
    )
  }
}
